<!-- =========================================================================================
  File Name: WarehouseEdit.vue
  Description: Warehouse Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <vs-alert color="danger" title="Bodega no encontrada" :active.sync="id_not_found">
      <span>Datos de bodega con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'warehouses'}" class="text-inherit underline"> todas las bodegas</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="data_local" class="mb-2">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <div class="w-full">
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Código de bodega" v-model="data_local.code" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Nombre de la bodega" v-model="data_local.name" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-dropdownlist floatLabelType="Auto" placeholder="Ubicación" highlight=true :dataSource="locations" :fields="{text: 'name', value: 'id'}" v-model="data_local.locationId" :enabled="editing"></ejs-dropdownlist>
              </div>
              <div class="w-full">
                <ejs-textbox name="comments" :multiline="true" floatLabelType="Auto" placeholder="Comentarios" v-model="data_local.comments" :enabled="editing"/>
              </div>
            </div>
          </div>

        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" v-show="!editing" @click="editing = true">Editar</vs-button>
              <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" v-show="!editing" @click="confirmDeleteRecord">Eliminar</vs-button>
              <vs-button class="ml-auto" @click="save" v-show="editing" :disabled="!validateForm">Guardar cambios</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data" v-show="editing">Cancelar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js')

  import Vue from "vue";
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";

  Vue.use(TextBoxPlugin);
  Vue.use(DropDownListPlugin);

  export default {
    data() {
      return {
        loaded: false,
        editing: false,
        id: 0,
        locations: [],
        data: null,
        data_local: {
          id: 0,
          code: '',
          name: '',
          comments: '',
          locationId: 0,
          locationName: ''
        },
        id_not_found: false,
      }
    },
    methods: {
      reset_data() {
        if (this.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.editing = false;
        } else {
          this.$router.push({name: 'warehouses'});
        }
      },
      getData(id) {
        if (id) {
          if (id == 0) {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            var self = this;
            this.$http.post(deltaPOS_config.default.apiURL + '/stock/warehouses/data', {id: id, context: this.$store.state.AppActiveUser}).then(response => {
              if (response.data.success) {
                self.data = response.data.data;
                self.data_local = JSON.parse(JSON.stringify(response.data.data));
              } else {
                if (id > 0) {
                  this.id_not_found = true;
                }
              }
              self.$vs.loading.close();
              self.loaded = true;
            })
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      validateForm() {
        var message = '';
        if (!this.data_local.code || this.data_local.code == '') {
          message = 'Debe especificar un código';
        } else if (!this.data_local.name || this.data_local.name == '') {
          message = 'Debe especificar un nombre';
        } else if (!this.data_local.locationId || this.data_local.locationId == 0) {
          message = 'Debe seleccionar una ubicación';
        } else {
          var status = this.locations.filter(item => item.code == this.data_local.locationId);
          if (status.length <= 0) {
            message = 'Estado incorrecto';
          }
        }
        if (message != '') {
          this.$vs.notify({
            title: 'Error al guardar bodega',
            text: message,
            color: 'danger'
          });
        }
        return (message == '');
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando información de bodega',
            type: 'point'
          });
          var self = this;
          this.data_local.id = this.id;
          this.data_local.context = this.$store.state.AppActiveUser;
          this.data_local.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
          this.$http.post(deltaPOS_config.default.apiURL + '/stock/warehouses/save', this.data_local).then(response => {
            if (response.data.success) {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Datos de la bodega fueron actualizados correctamente',
                color: 'primary'
              });
              if (self.id == 0) {
                self.$router.push({name: 'warehouse', params: {id: response.data.data.id}});
              }
              this.editing = false;
            } else {
              self.$vs.notify({
                title: 'Error al actualizar',
                text: response.data.message,
                color: 'danger'
              });
            }
            this.$vs.loading.close();
          });
        }
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a eliminar bodega "${this.data.name}"`,
          accept: this.deleteRecord,
          acceptText: "Delete"
        })
      },
      deleteRecord() {
        this.$vs.loading({
          text: 'Eliminando bodega',
          type: 'point'
        });
        var self = this;
        this.$http.post(deltaPOS_config.default.apiURL + '/stock/warehouses/delete', {id: this.id, context: this.$store.state.AppActiveUser}).then(response => {
          if (response.data.success) {
            self.$vs.notify({
              title: 'Información eliminada',
              text: 'Bodega fue eliminada correctamente',
              color: 'primary'
            });
            self.$router.push({name: 'warehouses'});
          } else {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: response.data.message,
              color: 'danger'
            });
          }
          this.editing = false;
          this.$vs.loading.close();
        });
      }
    },

    mounted() {
      this.id = parseInt(this.$route.params.id);
      this.$vs.loading({
        text: 'Cargando bodega',
        type: 'point'
      });
      var self = this;
      this.$http
        .post(deltaPOS_config.default.apiURL + '/lists/locations/list', this.$store.state.AppActiveUser)
        .then(response => {
          if (response.data.success) {
            self.locations = response.data.data;
          }
          this.getData(this.id);
        });
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';*/
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/

  .wrapper {
    max-width: 250px;
    margin: 0 auto;
  }

  .e-grid .e-altrow {
    background-color: #fafafa;
  }

  #avatar-col {
    width: 12rem;
  }

  #page-stock-warehous-edit {
    table {
      td {
        vertical-align: top;
        min-width: 140px;
        padding-bottom: .4rem;
        word-break: break-all;
      }

      &:not(.permissions-table) {
        td {
          @media screen and (max-width: 370px) {
            display: block;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
    #account-info-col-1 {
      width: calc(100% - 12rem) !important;
    }
  }

</style>
